import { useEffect, useState } from "react";
import axios from "axios";
import { Instagram } from "lucide-react";
import { Reveal, SectionTitle } from "./Reveal";
import { useLang } from "@/i18n/LangContext";
import { API, INSTAGRAM } from "@/lib/api";

const loadEmbed = () => {
  if (window.instgrm) {
    window.instgrm.Embeds.process();
    return;
  }
  if (document.getElementById("ig-embed")) return;
  const s = document.createElement("script");
  s.id = "ig-embed";
  s.async = true;
  s.src = "https://www.instagram.com/embed.js";
  document.body.appendChild(s);
};

export default function InstagramFeed() {
  const { tr } = useLang();
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    axios.get(`${API}/instagram`).then((r) => setPosts(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    if (posts.length) loadEmbed();
  }, [posts]);
  if (!posts.length) return null;
  return (
    <section className="py-20 sm:py-28" data-testid="instagram-feed">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <SectionTitle eyebrow="Instagram" title={tr("Latest from @dr._cora", "Lo último de @dr._cora")} />
          <Reveal from="right"><a href={INSTAGRAM} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#00C9B7] hover:text-white" data-testid="instagram-feed-follow"><Instagram size={16} /> {tr("Follow on Instagram →", "Síguenos en Instagram →")}</a></Reveal>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 items-start">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.1} className="rounded-3xl overflow-hidden bg-white" data-testid={`instagram-post-${i}`}>
              <blockquote className="instagram-media" data-instgrm-permalink={p.url} data-instgrm-version="14" style={{ margin: 0, width: "100%", minWidth: 0, border: 0 }}>
                <a href={p.url} target="_blank" rel="noreferrer" className="block p-6 text-center text-sm text-slate-700">{tr("View this post on Instagram", "Ver esta publicación en Instagram")}</a>
              </blockquote>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
